import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function orderHistoryReducer(
  state = initialState.orderHistory,
  action
) {
  switch (action.type) {
    case types.GET_ACTIVE_ORDERS_SUCCESS:
      return {
        ...state,
        activeOrdersPage: action.activeOrders && action.activeOrders.page,
        _embedded: {
          ...(state && state._embedded),
          activeOrders:
            action.activeOrders &&
            action.activeOrders._embedded &&
            action.activeOrders._embedded.orderDtoList,
        },
      };
    case types.GET_INVOICES_SUCCESS:
      return {
        ...state,
        _links: {...(state && state._links), ...action.invoices._links},
        invoicesPage: action.invoices && action.invoices.page,
        _embedded: {
          ...(state && state._embedded),
          invoices:
            action.invoices &&
            action.invoices._embedded &&
            action.invoices._embedded.invoiceDtoes,
        },
      };
    case types.GET_CANCELED_ORDERS_SUCCESS:
      return {
        ...state,
        cancelledOrdersPage:
          action.cancelledOrders && action.cancelledOrders.page,
        _embedded: {
          ...(state && state._embedded),
          cancelledOrders:
            action.cancelledOrders &&
            action.cancelledOrders._embedded &&
            action.cancelledOrders._embedded.orderDtoList,
        },
      };
    case types.SET_ACCOUNTS_SUCCESS:
    case types.REMOVE_AUTH_SUCCESS:
      return null;
    default:
      return state;
  }
}
